<div wnlGroup #wnlGroup="wnlGroup">
  <div class="wnl-header">
    @if(patient().isObstetric()) {
    <p>
      WNL: Voiding without difficulty, Urine straw color, no bladder distention noted. Continent with
      bladder control. Lochia appropriate for post-partem day if applicable.
    </p>
    } @else if (patient().isPediatric()) {
    <p>
      WNL: Voiding without difficulty, Urine straw color, no bladder distention noted. Continent with
      bladder control. Vaginal opening visible (female) or testicles descended bilaterally (male).
    </p>
    } @else {
      <p>
        WNL: Voiding without difficulty, Urine straw color, no bladder distention noted. Continent with
        bladder control.
      </p>
    }
    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
      (change)="wnlGroup.setAllWnl($event.checked)"
      [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
      All Within Normal Limits
    </mat-checkbox>
  </div>

  <div [formGroup]="formGroup()" class="form-container">
  @if (patient().isObstetric()) {
  <assessment-row title="Urine Characteristics">
    <emr-checkbox-group [control]="formGroup().controls.urineCharacteristics" [options]="urineCharacteristicsOptions"
      [wnlControl]="'urineCharacteristics'" [wnlDefault]="[]" />
  </assessment-row>

  <assessment-row title="Urine Color">
    <emr-input type="select" [control]="formGroup().controls.urineColor" [options]="urineColorOptions"
      [wnlControl]="'urineColor'" [wnlDefault]="'WNL'" />
  </assessment-row>

  <assessment-row title="Urinary Pattern">
    <emr-checkbox-group [control]="formGroup().controls.urinaryPattern" [options]="urinaryPatternOptions"
      [wnlControl]="'urinaryPattern'" [wnlDefault]="[]" />
  </assessment-row>

  <h2>Foley</h2>
  <assessment-row title="Justification">
    <emr-input type="text" width="50%" [control]="formGroup().controls.foleyJustification"
      [wnlControl]="'foleyJustification'" [wnlDefault]="''" [wnlClearValue]="null" />
  </assessment-row>

  <assessment-row title="Securement">
    <emr-input type="text" width="50%" [control]="formGroup().controls.foleySecurement"
      [wnlControl]="'foleySecurement'" [wnlDefault]="''" [wnlClearValue]="null" />
  </assessment-row>

  <assessment-row title="Abnormal Lochia">
    <emr-checkbox [control]="formGroup().controls.hasAbnormalLochia" label="Yes" [wnlControl]="'hasAbnormalLochia'"
      [wnlDefault]="false"></emr-checkbox>
  </assessment-row>

  @if (formGroup().controls.hasAbnormalLochia.value){
  <assessment-row title="Inappropriate Color?">
    <emr-checkbox [control]="formGroup().controls.abnormalLochiaHasInappropriateColor" label=""></emr-checkbox>
  </assessment-row>

  <assessment-row title="Heavy Bleeding?">
    <emr-checkbox [control]="formGroup().controls.abnormalLochiaHasHeavyBleeding" label=""></emr-checkbox>
  </assessment-row>

  <assessment-row title="Foul Odor?">
    <emr-checkbox [control]="formGroup().controls.abnormalLochiaHasFoulOdor" label=""></emr-checkbox>
  </assessment-row>

  <assessment-row title="Other">
    <emr-input type="text" [control]="formGroup().controls.abnormalLochiaOther"></emr-input>
  </assessment-row>
  }

  <assessment-row title="Abnormal Uterine Assessment">
    <emr-checkbox [control]="formGroup().controls.hasAbnormalUterine" label="Yes"
      [wnlControl]="'hasAbnormalUterine'" [wnlDefault]="false"></emr-checkbox>
  </assessment-row>

  @if (formGroup().controls.hasAbnormalUterine.value) {
  <assessment-row title="Fundal Location">
    <emr-input type="text" [control]="formGroup().controls.abnormalUterineFundalLocation"></emr-input>
  </assessment-row>
  <assessment-row title="Fundal Feel">
    <emr-input type="text" [control]="formGroup().controls.abnormalUterineFundalFeel"></emr-input>
  </assessment-row>
  <assessment-row title="Contractions Present?">
    <emr-checkbox [control]="formGroup().controls.areContractionsPresent" label=""></emr-checkbox>
  </assessment-row>
  @if (formGroup().controls.areContractionsPresent.value){
  <div>
    <p>Contraction Strength</p>
    <emr-input type="text" [control]="formGroup().controls.contractionsStrength"></emr-input>
    <p>Contraction Duration</p>
    <emr-input type="text" [control]="formGroup().controls.contractionsDuration"></emr-input>
    <p>Contraction Frequency</p>
    <emr-input type="text" [control]="formGroup().controls.contractionsFrequency"></emr-input>
  </div>
  }
  <assessment-row title="Fetal Heart Tones Present?">
    <emr-checkbox [control]="formGroup().controls.hasFetalHeartTones" label=""></emr-checkbox>
  </assessment-row>
  @if (formGroup().controls.hasFetalHeartTones.value) {
  <div>
    <p>Accelerations Noted</p>
    <emr-input type="text" [control]="formGroup().controls.fetalHeartTonesAccelerationsNoted"></emr-input>
    <p>Decelerations Noted</p>
    <emr-input type="text" [control]="formGroup().controls.fetalHeartTonesDecelerationsNoted"></emr-input>
    <p>FHT Variability</p>
    <emr-input type="text" [control]="formGroup().controls.fetalHeartTonesVariability"></emr-input>
  </div>
  }

  <assessment-row title="Abnormal Vaginal Assessment">
    <emr-checkbox [control]="formGroup().controls.hasAbnormalVaginalAssessment" label=""></emr-checkbox>
  </assessment-row>

  @if (formGroup().controls.hasAbnormalVaginalAssessment.value) {
  <p>Episiotomy</p>
  <emr-input type="text" [control]="formGroup().controls.abnormalVaginalEpisiotomy"></emr-input>
  <p>Tear</p>
  <emr-input type="text" [control]="formGroup().controls.abnormalVaginalTear"></emr-input>
  <p>Dilaton</p>
  <emr-input type="text" [control]="formGroup().controls.abnormalVaginalDilation"></emr-input>
  <p>Station</p>
  <emr-input type="text" [control]="formGroup().controls.abnormalVaginalStation"></emr-input>
  }
  }

  } @else {

  <assessment-row title="Urine Characteristics">
    <emr-checkbox-group [control]="formGroup().controls.urineCharacteristics" [options]="urineCharacteristicsOptions"
      [wnlControl]="'urineCharacteristics'" [wnlDefault]="[]" [wnlClearValue]="null" />
  </assessment-row>

  <assessment-row title="Urine Color">
    <emr-input type="select" [control]="formGroup().controls.urineColor" [options]="urineColorOptions"
      [wnlControl]="'urineColor'" [wnlDefault]="'WNL'" />
  </assessment-row>

  @if (patient().isPediatric()) {
    <assessment-row title="Urinary Pattern">
      <emr-checkbox-group [control]="formGroup().controls.urinaryPattern" [options]="urinaryPatternOptionsPediatric"
        [wnlControl]="'urinaryPattern'" [wnlDefault]="[]" [wnlClearValue]="null" />
    </assessment-row>

    <assessment-row title="Abnormal Testes?">
      <emr-checkbox [control]="formGroup().controls.abnormalTestes" label="Yes" [wnlControl]="'abnormalTestes'"
        [wnlDefault]="false"></emr-checkbox>
    </assessment-row>
    @if (formGroup().controls.abnormalTestes.value) {
      <assessment-row title="Testes Abnormality Details">
        <emr-input type="text" [control]="formGroup().controls.testesAbnormalityDetails"></emr-input>
      </assessment-row>
    }
    <assessment-row title="Abnormal Vaginal Opening?">
      <emr-checkbox [control]="formGroup().controls.abnormalVaginalOpening" label="Yes"
        [wnlControl]="'abnormalVaginalOpening'" [wnlDefault]="false"></emr-checkbox>
    </assessment-row>
    @if (formGroup().controls.abnormalVaginalOpening.value) {
      <assessment-row title="Vaginal Opening Abnormality Details">
        <emr-input type="text" [control]="formGroup().controls.vaginalOpeningAbnormalityDetails"></emr-input>
      </assessment-row>
    }
  } @else {
    <assessment-row title="Urinary Pattern">
      <emr-checkbox-group [control]="formGroup().controls.urinaryPattern" [options]="urinaryPatternOptions"
        [wnlControl]="'urinaryPattern'" [wnlDefault]="[]" [wnlClearValue]="null" />
    </assessment-row>
  }

  <h2>Foley</h2>
  <assessment-row title="Justification">
    <emr-input type="text" width="50%" [control]="formGroup().controls.foleyJustification"
      [wnlControl]="'foleyJustification'" [wnlDefault]="''" [wnlClearValue]="null" />
  </assessment-row>

  <assessment-row title="Securement">
    <emr-input type="text" width="50%" [control]="formGroup().controls.foleySecurement"
      [wnlControl]="'foleySecurement'" [wnlDefault]="''" [wnlClearValue]="null" />
  </assessment-row>

  <assessment-row title="Other Findings">
    <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
      [wnlDefault]="''" [wnlClearValue]="null" />
  </assessment-row>
  }
</div>
</div>